// 🔥 DEV FEATURE MODE
// true  → use DEV_FEATURES (for UI testing)
// false → use backend / localStorage features (prod behavior)
const DEV_FEATURE_MODE = false;

/**
 * 🧪 DEV FEATURES
 * Comment / uncomment to test UI states
 */
const DEV_FEATURES = [
  // "NB_MGT",
  "TTBL_MGT",
  // "STUD_ATT",
  // "FEE_MGT",
  "OL_PERF",
  // "LEC_SUM",
  "LEC_SUM",
  "AS_HW",
  "TCHR_ASS",
  // "ADAPT_ASS",
  // "AUTO_ASS",
  // "QUES_LIB",
  "OL_LEC_2W_NR",
  "AUTO_ASS",
  // "OL_LEC_1W_WR",
  "OSM_MARK"
];

export const ALL_FEATURES = [
  { code: "REG_LOG", name: "Register & Login" },
  { code: "SCH_DB", name: "School Database Organizer" },
  { code: "TCHR_ALLOC", name: "Teacher Allocation" },
  { code: "TTBL_MGT", name: "Timetable Management" },
  { code: "LEC_SUM", name: "Lecture Summary Management" },
  { code: "TCHR_WL", name: "Teacher Workload" },
  { code: "OL_LEC_2W_NR", name: "Online Lecture 2-Way without Recordings" }, // bbb live check
  { code: "OL_LEC_2W_WR", name: "Online Lecture 2-Way with Recordings" }, /// bbb live check
  { code: "OL_LEC_1W_NR", name: "Online Lecture 1-Way without Recordings" }, // for youtube live check
  { code: "OL_LEC_1W_WR", name: "Online Lecture 1-Way with Recordings" }, //for yutube live check
  { code: "CONT_LIB", name: "Content Library" },
  { code: "DRM_CONT", name: "DRM Content" },
  { code: "STUD_ATT", name: "Student Attendance & Leave Management" },
  {
    code: "TEACH_ATT",
    name: "Teacher Attendance & Leave Management",
  },
  { code: "SELF_ATT", name: "Student Self-Attendance" },
  { code: "SALARY_MGT", name: "Salary & Payroll Management" },
  { code: "FEE_MGT", name: "Fee Management" },
  { code: "NB_MGT", name: "Notice Board Management" },
  { code: "QUES_LIB", name: "Question Library" },
  { code: "AI_QUERY", name: "AI Query Generator" },
  { code: "AS_HW", name: "Assignment - Homework" },
  { code: "AS_PR", name: "Assignment - Pre-Read" },
  { code: "AS_ACT", name: "Assignment - Activity" },
  { code: "ADAPT_ASS", name: "Adaptive Assessment" },
  { code: "AUTO_ASS", name: "Auto-Evaluated Assessment" },
  { code: "TCHR_ASS", name: "Teacher-Evaluated Assessment" },
  { code: "COMMUNITY", name: "Community" },
  { code: "DOUBT_SOLV", name: "Doubt Solving" },
  { code: "OL_PERF", name: "Online Performance" },
  { code: "OFFL_PERF", name: "Offline Performance" },
  { code: "STUDY_PLN", name: "Study Planner" },
  { code: "SELF_ASS", name: "Self Assessment" },
  { code: "AI_BOT", name: "AI ChatBot" },
  { code: "VOC_MGT", name: "VOC Management (Voice of Customer)" },
  { code: "VAL_ORIENT", name: "Value Orientation" },
  { code: "CLASS_GAL", name: "Class Gallery" },
  { code: "PHYGITAL", name: "Phygital Conversion" },
  { code: "WHT_LABEL", name: "Whitelabelling" },
  { code: "PERFORMANCE_REPORT", name: "Performance Report" },
  {
    code: "AUTO_ASS_SUBJECTIVE",
    name: "Auto-Evaluation for Subjective Questions (AI)",
  },
  { code: "OSM_MARK", name: "Online Script Marking" },
];

export const getFeaturesFromStorage = () => {
  // 🧪 DEV override
  if (DEV_FEATURE_MODE) {
    return DEV_FEATURES;
  }

  try {
    const raw = localStorage.getItem("features");
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const hasFeature = (featureCode) => {
  const features = getFeaturesFromStorage();

  // backend ne kuch nahi bheja → allow all (prod-safe)
  if (!features || features.length === 0) return true;

  return features.includes(featureCode);
};

export const hasHW = hasFeature("AS_HW");
export const hasPreRead = hasFeature("AS_PR");
export const hasActivity = hasFeature("AS_ACT");

export const HasAdaptiveAssessment = hasFeature("ADAPT_ASS");
console.log(HasAdaptiveAssessment, "HasAdaptiveAssessment");
export const HasAutoEvaluatedAssessment = hasFeature("AUTO_ASS");
export const hasDescriptiveAutoAssessment = hasFeature("AUTO_ASS_SUBJECTIVE");
export const HasTeacherEvaluatedAssessment = hasFeature("TCHR_ASS");

export const fullAsessment =
  HasAdaptiveAssessment ||
  HasAutoEvaluatedAssessment ||
  HasTeacherEvaluatedAssessment;
